import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import AssetForm from './components/asset-form/AssetForm';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { ModelName } from '@casops/store/api';
import { useModelFormTitle } from '@casops/components/layout/model-form/useModelFormTitle';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useGetAssetQuery } from '@casops/store/apis/registeredAssetsApi';
import { useListConfigurationGroupsQuery } from '@casops/store/apis/configurationGroupsApi';
import { useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';

const modelName = ModelName.Asset;

export function ManageAsset(): ReactElement {
  const title = useModelFormTitle(modelName);

  const { isLoaded: isAssetLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetAssetQuery,
  });

  // Load form dependencies
  const { data: configGroups, isSuccess: isSuccessConfigGroups } = useListConfigurationGroupsQuery(
    undefined,
    {
      refetchOnMountOrArgChange: 60,
    },
  );

  const { data: assetGroups, isSuccess: isSuccessAssetGroups } = useListAssetGroupsQuery(
    undefined,
    {
      refetchOnMountOrArgChange: 60,
    },
  );

  // Combine all loading states
  const isLoaded = [
    isAssetLoaded,
    isSuccessConfigGroups,
    configGroups,
    isSuccessAssetGroups,
    assetGroups,
  ].every(Boolean);

  // Include dependency data in renderKey
  const renderKey = useRenderKey({ item, configGroups, assetGroups });

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <AssetForm key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ManageAsset;
